import { useTheme } from 'next-themes'
import React from 'react'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground hover:{from-[#CBDA58] to-[#A5B620]}',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}

// Custom announcement toaster with specific styling for banner-like announcements
const AnnouncementToaster = () => {
  return (
    <Sonner
      duration={Infinity}
      className="announcement-toaster group relative"
      style={
        {
          width: '100%',
          zIndex: '50',
        } as React.CSSProperties
      }
      position="bottom-right"
      toastOptions={{
        classNames: {
          content: 'text-white text-sm font-normal',
          toast:
            'z-[0] !w-[calc(100vw-8px)] !max-w-[600px] flex flex-row gap-2 text-white min-[600px]:w-[450px] rounded-t-lg min-[600px]:rounded-lg p-4 z-[50] bg-blue-800/[.85] backdrop-blur-lg text-white border-none shadow-md shadow-blue-800/50 max-[600px]:mx-[-12px] max-[600px]:mb-[-16px]',
          description: '',
          actionButton:
            'bg-gradient-to-br from-[#DEE897] to-[#CCDE44] font-medium px-3 py-2 rounded-lg text-black',
          cancelButton:
            'order-last bg-gray-300/0 px-2 py-3 text-white transition-all hover:bg-gray-300/10 rounded-lg mt-auto justify-self-center',
        },
      }}
    />
  )
}

export { Toaster, AnnouncementToaster }
